import React from 'react';
import './main.css'

function Main1() {
    return (<>

        <ul>
            <img alt='Helping famalies poster' src='https://i.imgur.com/50BqvPg.png' className='img2 box-shadow' />
            {/* <div className="headerimg headrow2b ">
                <img src='https://i.imgur.com/KcNlmcE.png[/img]'
                    alt='company logo' style={{ width: "", float: '' }} className="logo drop-shadow-filter " />
            </div> */}
        </ul>
    </>);
}

export default Main1;